import { apis } from "../../../backend";
import { getAccessToken } from "../../../utils/user";

/**
 * Starts predictive mode.
 */
export async function startPredictiveMode(leadListId: string) {
  await apis.dial.post(`/predictive-dial-v1/join/${leadListId}`);
}

/**
 * Ends predictive mode for this user.
 */
export async function endPredictiveMode() {
  if (typeof window.navigator?.sendBeacon === 'function') {
    const opts = new Blob([JSON.stringify({
      authorization: getAccessToken()
    })], { type: 'application/json' });

    window.navigator.sendBeacon(apis.dial.getUrl(`/predictive-dial-v1/leave`), opts);
  } else {
    await apis.dial.post(`/predictive-dial-v1/leave`);
  }
}